import { Box, styled } from '@mui/material'
import { PageProps } from './Page.types'

const Wrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'center',
})<PageProps>(({ center }) => ({
  display: 'flex',
  flex: 'auto',
  padding: '0px 36px',
  paddingBottom: '18px',
  overflow: 'auto',
  scrollbarWidth: 'none',
  ...(center ? { justifyContent: 'center', alignItems: 'center' } : {}),
}))

export const Page = ({ children, center, sx }: PageProps) => {
  return (
    <Wrapper center={center} sx={sx}>
      {children}
    </Wrapper>
  )
}
